// Inside /utils/history.js
import {createBrowserHistory as createHistory} from 'history';

export default createHistory();